import { Locales } from '@griply/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createPushToken,
  fetchFreshPushToken,
  resetPushRegistration,
} from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

import { queryKey as cacheQueryKey } from './use-cached-push-notification-token-query';
import { queryKey as fcmTokenDocQueryKey } from './use-fcm-token-doc-query';

export const useResetPushRegistrationMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, locale }: { userId: ID; locale: Locales }) => {
      await resetPushRegistration(userId);

      const freshToken = await fetchFreshPushToken();
      if (freshToken) {
        await createPushToken(userId, freshToken, locale);
      }

      await client.invalidateQueries({ queryKey: [cacheQueryKey] });
      await client.invalidateQueries({ queryKey: [fcmTokenDocQueryKey] });
    },
  });
};
